var map = {
	"./big-parcel.webp": 8258,
	"./business-card.webp": 5165,
	"./call-black.webp": 3201,
	"./call.webp": 899,
	"./clock-black.webp": 5631,
	"./code.webp": 2961,
	"./communication.webp": 3814,
	"./company.webp": 7982,
	"./github.webp": 3523,
	"./link.webp": 9525,
	"./linkedin.webp": 7766,
	"./lock.webp": 55,
	"./mail-black.webp": 6277,
	"./mail.webp": 9133,
	"./message.webp": 9216,
	"./presentation.webp": 2969,
	"./promotion.webp": 2366,
	"./seo.webp": 8740,
	"./shop.webp": 5193,
	"./techs/api.webp": 8882,
	"./techs/bootstrap.webp": 2693,
	"./techs/css.webp": 6992,
	"./techs/firebase.webp": 7778,
	"./techs/git.webp": 6608,
	"./techs/github-yellow.webp": 4451,
	"./techs/github.webp": 8095,
	"./techs/html.webp": 2329,
	"./techs/javascript.webp": 7077,
	"./techs/json.webp": 5070,
	"./techs/model.webp": 7394,
	"./techs/nodejs.webp": 1287,
	"./techs/npm.webp": 5836,
	"./techs/parcel.webp": 380,
	"./techs/php.webp": 703,
	"./techs/react.webp": 4512,
	"./techs/responsive.webp": 130,
	"./techs/rest.webp": 1742,
	"./techs/sass.webp": 4273,
	"./techs/seo.webp": 7157,
	"./techs/sync.webp": 1470,
	"./techs/vuejs.webp": 3710,
	"./techs/webpack.webp": 7056,
	"./techs/wordpress.webp": 9520,
	"./trust.webp": 8761,
	"./website.webp": 5681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1127;